// extracted by mini-css-extract-plugin
export default {"root":"EditCommentForm-root-65ca088b19f25316df517355283cb845"};